export const CONTENT_SECTIONS = {
  AWARD: 'Award',
  COMMON_QUESTIONS: 'QuestionsList',
  CONTACT_DETAILS: 'ContactDetails',
  EXTERNAL_CONTENT: 'ExternalContent',
  HEADER: 'header',
  OFFER: 'offer',
  PRODUCT_LIST: 'ProductList',
  PRODUCT_LIST_SECTION: 'ProductListSection',
  PROMOTIONAL_TILES: 'PromotionalCtaList',
  SALES_JOURNEY: 'SalesJourney',
  SELLING_POINTS_GROUP: 'SellingPointGroup',
  TERMS_AND_CONDITIONS: 'termsAndConditions',
  TOPIC_GROUP: 'TopicGroup',
  VALUE_PROPOSITIONS: 'ValuePropositionsObject',
  YOUTH_DISCOUNT_SLIDER: 'YouthDiscountSlider',
} as const;
